// extracted by mini-css-extract-plugin
export default {"activityContainer":"UserActivity_activityContainer__fbnFu","btnActivity":"UserActivity_btnActivity__Y7Cyp","title":"UserActivity_title__Krf8n"};